"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _getLevelHelper = require("../../../helpers/getLevelHelper");
var _KYC_ManualFormComponent = _interopRequireDefault(require("./KYC_ManualFormComponent"));
var _reduxForm = require("redux-form");
var _userActions = require("../../../redux/actions/userActions");
var _kycManualActions = require("../../../redux/actions/kycManualActions");
var _kycLevelsSelectors = require("../../../redux/selectors/kycLevelsSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = (0, _kycLevelsSelectors.kycLevelFormSelector)(state),
    verificationLevel = _kycLevelFormSelector.verificationLevel,
    kycConfig = _kycLevelFormSelector.kycConfig,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userName = _kycLevelFormSelector.userName,
    email = _kycLevelFormSelector.email,
    processing = _kycLevelFormSelector.processing;
  var level = (0, _getLevelHelper.getDisplayLevel)(kycConfig, verificationLevel + 1);
  return {
    // Component
    level: level,
    formValues: (0, _reduxForm.getFormValues)('KYC_Manual_Form')(state),
    processing: processing,
    // KYCManualHelpers
    alphaPointUserID: alphaPointUserID,
    email: email,
    currentLevel: verificationLevel,
    userName: userName
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    submitUserConfig: function submitUserConfig(setUserConfigPayload) {
      return dispatch((0, _userActions.setUserConfig)(setUserConfigPayload.UserId, setUserConfigPayload.UserName, setUserConfigPayload.Config, false));
    },
    submitInfoManual: function submitInfoManual(setUserConfigForManualKYCPayload) {
      return dispatch((0, _kycManualActions.setUserConfigForManualKYC)(setUserConfigForManualKYCPayload.UserId, setUserConfigForManualKYCPayload.UserName, setUserConfigForManualKYCPayload.underReviewLevel, setUserConfigForManualKYCPayload.Config));
    },
    reset: function reset() {
      return dispatch((0, _reduxForm.reset)('KYC_Manual_Form'));
    }
  };
};
var KYC_ManualForm = (0, _reduxForm.reduxForm)({
  form: 'KYC_Manual_Form',
  onSubmit: function onSubmit() {}
})(_KYC_ManualFormComponent["default"]);
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(KYC_ManualForm);